import React from 'react';
import { SnackbarProvider } from 'notistack';
import { useTheme } from '@material-ui/core';
import '../styles/notistack.css';

export const NotistackProvider = ({ children }) => {
    const notistackRef = React.createRef();
    const theme = useTheme();

    return (
        <SnackbarProvider
            dense
            maxSnack={3}
            ref={notistackRef}
            ContentProps={{
                style: {
                    borderRadius: '4px',
                    ...theme.typography.body1,
                    minHeight: 75,
                    maxWidth: 600,
                },
            }}
        >
            {children}
        </SnackbarProvider>
    );
};
